import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VStepper } from 'vuetify/lib/components/VStepper';
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
import ClickOutside from 'vuetify/lib/directives/click-outside';

import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VNavigationDrawer, {
    directives: [{
      def: ClickOutside,
      name: "click-outside",
      rawName: "v-click-outside",
      value: _vm.clickOutsideDrawer,
      expression: "clickOutsideDrawer"
    }],
    attrs: {
      fixed: "",
      bottom: "",
      right: "",
      width: _vm.drawerWidth,
      temporary: ""
    },
    model: {
      value: _vm.drawer,
      callback: function callback($$v) {
        _vm.drawer = $$v;
      },
      expression: "drawer"
    }
  }, [_c("div", {
    staticClass: "drawer"
  }, [_c("section", {
    staticClass: "drawer-header"
  }, [_c("div", {
    staticClass: "drawer-title"
  }, [_c(VBtn, {
    staticClass: "primary",
    attrs: {
      rounded: ""
    },
    on: {
      click: _vm.close
    }
  }, [_c(VIcon, {
    attrs: {
      dark: ""
    }
  }, [_vm._v("mdi-close")])], 1), _c("h2", [_vm._v(_vm._s(_vm.order.reference_order.shorterReference()) + " delivered")])], 1)]), _vm.hasParentContainerNotDelivered ? _c(VAlert, {
    staticClass: "--small",
    attrs: {
      dense: "",
      outlined: "",
      type: "warning",
      color: "orange",
      text: ""
    }
  }, [_vm._v(" The parent container order must be delivered ")]) : [_c(VStepper, {
    key: _vm.steps.length,
    attrs: {
      vertical: ""
    },
    model: {
      value: _vm.currentStep,
      callback: function callback($$v) {
        _vm.currentStep = $$v;
      },
      expression: "currentStep"
    }
  }, [_vm._l(_vm.steps, function (step) {
    var _vm$order$importer, _vm$order$importer2;
    return [_c("div", {
      key: "step_".concat(step.id)
    }, [_c(VStepperStep, {
      attrs: {
        step: step.id,
        complete: _vm.currentStep > step.id,
        rules: step.rules,
        editable: ""
      }
    }, [_vm._v(" " + _vm._s(step.title) + " "), _c("small", [_vm._v(_vm._s(step.inf))])]), step.key === "delivery-date" ? _c(VStepperContent, {
      key: "delivery-date_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_vm.errorOccurred ? _c("p", {
      staticClass: "errorLabel text-sm text-center"
    }, [_vm._v(" No date has been selected! ")]) : _vm._e(), _c("div", {
      staticClass: "date-picker"
    }, [_c(VDatePicker, {
      attrs: {
        disabled: _vm.isUpdatingStatus,
        max: _vm.today
      },
      model: {
        value: _vm.form.deliveryDate,
        callback: function callback($$v) {
          _vm.$set(_vm.form, "deliveryDate", $$v);
        },
        expression: "form.deliveryDate"
      }
    })], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary"
      },
      on: {
        click: function click($event) {
          return _vm.confirmDeliveryDate(_vm.form.deliveryDate);
        }
      }
    }, [_vm._v(" Continue ")])], 1)]) : _vm._e(), step.key === "container-suborders" ? _c(VStepperContent, {
      key: "container-suborders_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [_vm.isContainerOrderWithAnySuborderNotInDelivery ? _c("div", {
      staticClass: "flex mb-2"
    }, [_c(VAlert, {
      staticClass: "--small",
      attrs: {
        dense: "",
        outlined: "",
        type: "warning",
        color: "orange",
        text: ""
      }
    }, [_vm._v(" Reminder : You should schedule the delivery of the suborders ")])], 1) : _vm._e(), _c("div", [_c(VDataTable, {
      staticClass: "elevation-2 --background-transparent --no-shadow --border-1",
      attrs: {
        headers: _vm.subordersTableHeaders,
        items: _vm.order.containerSubOrders,
        "items-per-page": -1,
        "loading-text": "Loading... Please wait",
        "hide-default-footer": "",
        "disable-sort": ""
      },
      scopedSlots: _vm._u([{
        key: "item.reference",
        fn: function fn(_ref) {
          var item = _ref.item;
          return [_c("div", {
            staticClass: "ml-1"
          }, [_c("router-link", {
            staticClass: "router-link",
            attrs: {
              to: _vm.orderDetails(item.id_order),
              target: "_blank"
            }
          }, [_vm._v(" " + _vm._s(item.reference_order.shorterReference()) + " ")])], 1), _c("div", [_c("span", {
            class: ["badge line-height-1_1", item.status === _vm.orderStatus.find(function (x) {
              return x.id === "CANCELLED";
            }).status ? "danger" : item.status === _vm.orderStatus.find(function (x) {
              return x.id === "DELIVERY";
            }).status || item.status === _vm.orderStatus.find(function (x) {
              return x.id === "SUBCONTAINER_PUT_INBOUND";
            }).status ? "success" : "warning"]
          }, [_vm._v(" " + _vm._s(_vm.getOrderStatusLabel(item.status)) + " ")])])];
        }
      }, {
        key: "item.user",
        fn: function fn(_ref2) {
          var item = _ref2.item;
          return [_c("div", {
            domProps: {
              innerHTML: _vm._s(String.parseForVHtml(_vm.getFullNameUserHtml(item.user, true, true)))
            }
          })];
        }
      }, {
        key: "item.deliveryAddress",
        fn: function fn(_ref3) {
          var _item$delivery_addres;
          var item = _ref3.item;
          return [item.isSubcontainerPutInbound ? _c("div", {
            staticClass: "text-italic"
          }, [_vm._v(" Put Inbound ")]) : [_c("div", {
            staticClass: "text-smaller text-italic text-underline"
          }, [_vm._v("Direct delivery")]), _c("div", [_vm._v(" " + _vm._s("".concat(item.delivery_address.city, ", ").concat(item.delivery_address.country.iso_code).concat((_item$delivery_addres = item.delivery_address.state) !== null && _item$delivery_addres !== void 0 && _item$delivery_addres.iso_state ? "-" + item.delivery_address.state.iso_state : "")) + " ")])]];
        }
      }, {
        key: "item.amount",
        fn: function fn(_ref4) {
          var item = _ref4.item;
          return [_vm._v(" " + _vm._s(_vm.formatPrice(item.total_amount_currency)) + " " + _vm._s(_vm.getSymbolCurrency(item.currency)) + " ")];
        }
      }], null, true)
    }), _c("div", {
      staticClass: "text-smaller mt-1"
    }, [_c("div", {
      staticClass: "flex justify-end"
    }, [_c("div", [_vm._v("Suborders Nb Bottles :")]), _c("div", {
      staticClass: "text-bold"
    }, [_vm._v(_vm._s(_vm.order.containerSubOrdersQuantity))])]), _c("div", {
      staticClass: "flex justify-end"
    }, [_c("div", [_vm._v("Suborders Total :")]), _c("div", {
      staticClass: "text-bold"
    }, [_vm._v(" " + _vm._s(_vm.formatPrice(_vm.order.containerSubOrdersTotalAmountCurrency)) + " " + _vm._s(_vm.getSymbolCurrency(_vm.order.currency)) + " ")])])])], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary"
      },
      on: {
        click: function click($event) {
          return _vm.confirmDeliveryDate(_vm.form.deliveryDate);
        }
      }
    }, [_vm._v(" Continue ")])], 1)]) : _vm._e(), step.key === "mail" ? _c(VStepperContent, {
      key: "mail_".concat(step.id),
      attrs: {
        step: step.id
      }
    }, [!!_vm.order.warehouseMail ? _c("div", {
      staticClass: "mail-container"
    }, [_c(VTextField, {
      attrs: {
        label: "Warehouse mail",
        disabled: true,
        "hide-details": "auto"
      },
      model: {
        value: _vm.order.warehouseMail,
        callback: function callback($$v) {
          _vm.$set(_vm.order, "warehouseMail", $$v);
        },
        expression: "order.warehouseMail"
      }
    }), _c("div", {
      staticClass: "mail-icons"
    }, [_c(VTooltip, {
      attrs: {
        top: ""
      },
      scopedSlots: _vm._u([{
        key: "activator",
        fn: function fn(_ref5) {
          var on = _ref5.on,
            attrs = _ref5.attrs;
          return [_c(VIcon, _vm._g(_vm._b({
            attrs: {
              small: ""
            },
            on: {
              click: function click($event) {
                return _vm.copyToClipboard(_vm.order.warehouseMail);
              }
            }
          }, "v-icon", attrs, false), on), [_vm._v(" far fa-clipboard ")])];
        }
      }], null, true)
    }, [!_vm.isCopyingToClipboard ? _c("span", [_vm._v("Copy to clipboard")]) : _vm._e(), _vm.isCopyingToClipboard ? _c("div", [_c(VIcon, {
      staticStyle: {
        color: "green"
      }
    }, [_vm._v("mdi-check")]), _vm._v(" Copied ")], 1) : _vm._e()])], 1)], 1) : _vm._e(), _c(VExpansionPanels, {
      on: {
        change: _vm.changePanel
      },
      model: {
        value: _vm.openedPanel,
        callback: function callback($$v) {
          _vm.openedPanel = $$v;
        },
        expression: "openedPanel"
      }
    }, _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c(VExpansionPanel, {
        key: "expansion-panel_".concat(i),
        attrs: {
          id: "expansion-panel_".concat(i)
        }
      }, [_c(VExpansionPanelHeader, [_c(VBtn, {
        staticClass: "expansion-panel-header-close-btn",
        attrs: {
          icon: "",
          "data-cy": "step-mail-close-btn"
        },
        on: {
          click: function click($event) {
            return _vm.deleteTemplatePanel(i);
          }
        }
      }, [_c(VIcon, [_vm._v("mdi-close")])], 1), _vm._v(" " + _vm._s(emailTemplate.name) + " ")], 1), _c(VExpansionPanelContent, [!_vm.flattenPlaceholders.length ? _c(VSkeletonLoader, {
        staticStyle: {
          width: "100%"
        },
        attrs: {
          type: "image"
        }
      }) : [_vm.isNeedingSync ? _c(VBtn, {
        staticClass: "sync-btn",
        attrs: {
          rounded: "",
          loading: _vm.isSyncing
        },
        on: {
          click: _vm.syncLatestVersion
        }
      }, [_c(VIcon, [_vm._v("mdi-lightning-bolt")]), _vm._v(" Sync latest version ")], 1) : _vm._e(), _vm.openedPanel === i ? _c("MailTemplateForm", {
        key: "step_template_".concat(emailTemplate.id, "_").concat(i),
        attrs: {
          order: _vm.order,
          placeholders: _vm.emailPlaceholders,
          templates: _vm.emailTemplates,
          documents: _vm.documents,
          isDeletingTemplate: _vm.isDeletingTemplate
        },
        on: {
          edit: _vm.editTemplate,
          delete: _vm.deleteTemplate,
          change: _vm.changeTemplate,
          "click:new": _vm.newTemplate,
          "click:placeholder": _vm.clickPlaceholder
        },
        model: {
          value: _vm.form.emailTemplates[i],
          callback: function callback($$v) {
            _vm.$set(_vm.form.emailTemplates, i, $$v);
          },
          expression: "form.emailTemplates[i]"
        }
      }) : _vm._e()]], 2)], 1);
    }), 1), _c(VBtn, {
      staticClass: "new-email-btn",
      attrs: {
        rounded: ""
      },
      on: {
        click: _vm.newEmail
      }
    }, [_c(VIcon, [_vm._v("mdi-plus")]), _vm._v(" new e-mail ")], 1), _c(VDivider), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        "data-cy": "step-mail-continue-btn"
      },
      on: {
        click: _vm.confirmStep
      }
    }, [_vm._v(" Continue ")])], 1)], 1) : _vm._e(), step.key === "synthesis" ? _c(VStepperContent, {
      staticClass: "text-left",
      attrs: {
        step: step.id
      }
    }, [_vm.isInvalidMainForm ? _c("div", {
      staticClass: "errorLabel text-sm mb-4"
    }, [_c("p", [_vm._v("Make sure you have completed all the previous step.")]), _vm._l(_vm.errorsMainForm, function (error, i) {
      return _c("div", {
        key: "mainError-".concat(i)
      }, [_vm._v(" " + _vm._s(error) + " ")]);
    })], 2) : _c("div", {
      staticClass: "mb-4"
    }, [_vm._v(" Delivery date "), _c("strong", [_vm._v(" " + _vm._s(new Intl.DateTimeFormat("en-US", {
      dateStyle: "long"
    }).format(new Date(_vm.form.deliveryDate))) + " ")])]), (_vm$order$importer = _vm.order.importer) !== null && _vm$order$importer !== void 0 && _vm$order$importer.isInternalImporter && !_vm.order.isImporterInvoiced && ((_vm$order$importer2 = _vm.order.importer) === null || _vm$order$importer2 === void 0 || (_vm$order$importer2 = _vm$order$importer2.internalConfig) === null || _vm$order$importer2 === void 0 ? void 0 : _vm$order$importer2.invoicingMomentType) === _vm.IMPORTER.invoicingMomentTypes.ORDER_DELIVERED.id ? _c("div", {
      staticClass: "text-left mb-4"
    }, [_vm._v(" The final customer invoice, of internal importer, will be generated during this step. ")]) : _vm._e(), _c("div", {
      staticClass: "mb-4"
    }, [_c("div", {
      staticClass: "text-smaller text-italic"
    }, [_vm._v("Mail title : Order has been delivered")]), _c("div", {
      staticClass: "d-flex align-center"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: _vm.preventNotifyCustomer,
        callback: function callback($$v) {
          _vm.preventNotifyCustomer = $$v;
        },
        expression: "preventNotifyCustomer"
      }
    }), _vm.preventNotifyCustomer ? _c("span", {
      staticClass: "text-red text-bold"
    }, [_vm._v(" WILL NOT NOTIFY THE CUSTOMER (billing) BY AUTOMATIC PLATFORM MAIL ")]) : _c("span", {
      staticClass: "text-green text-bold"
    }, [_vm._v(" Will notify customer (billing) by automatic platform mail ")])], 1)]), _c("div", {
      staticClass: "mb-4"
    }, [_c("div", {
      staticClass: "text-smaller text-italic"
    }, [_vm._v("Mail title : Order has been delivered")]), _c("div", {
      staticClass: "d-flex align-center"
    }, [_c(VSwitch, {
      staticClass: "mt-0",
      attrs: {
        "hide-details": "auto"
      },
      model: {
        value: _vm.preventNotifyStaff,
        callback: function callback($$v) {
          _vm.preventNotifyStaff = $$v;
        },
        expression: "preventNotifyStaff"
      }
    }), _vm.preventNotifyStaff ? _c("span", {
      staticClass: "text-red text-bold"
    }, [_vm._v(" WILL NOT NOTIFY THE STAFF (accounting) BY AUTOMATIC PLATFORM MAIL ")]) : _c("span", {
      staticClass: "text-green text-bold"
    }, [_vm._v(" Will notify staff (accounting) by automatic platform mail ")])], 1)]), !!_vm.form.emailTemplates.length ? _c("div", {
      staticClass: "mb-4 mt-4"
    }, [_c("i", {
      staticClass: "fas fa-envelope mr-1"
    }), _vm._v(" Email(s) "), _c("strong", [_vm._v("(x" + _vm._s(_vm.form.emailTemplates.length) + ")")]), _vm._l(_vm.form.emailTemplates, function (emailTemplate, i) {
      return _c("div", {
        key: "synthesis_template_".concat(emailTemplate.id),
        staticClass: "text-sm"
      }, [_c(VDivider, {
        staticClass: "my-3"
      }), _c("div", {
        staticClass: "synthesis-email-line"
      }, [_c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isSuccessfulSending["".concat(emailTemplate.id, "_").concat(i)],
          expression: "isSuccessfulSending[`${emailTemplate.id}_${i}`]"
        }],
        staticClass: "sent-container"
      }, [_c("svg", {
        attrs: {
          version: "1.1",
          xmlns: "http://www.w3.org/2000/svg",
          viewBox: "0 0 130.2 130.2"
        }
      }, [_c("circle", {
        staticClass: "path circle",
        attrs: {
          fill: "none",
          stroke: "#73AF55",
          "stroke-width": "6",
          "stroke-miterlimit": "10",
          cx: "65.1",
          cy: "65.1",
          r: "62.1"
        }
      }), _c("polyline", {
        staticClass: "path check",
        attrs: {
          fill: "none",
          stroke: "#73AF55",
          "stroke-width": "6",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          points: "100.2,40.2 51.5,88.8 29.8,67.5 "
        }
      })]), _vm._v(" Sent! ")]), _c("div", {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.failedCustomMails["".concat(emailTemplate.id, "_").concat(i)],
          expression: "failedCustomMails[`${emailTemplate.id}_${i}`]"
        }],
        staticClass: "sent-container text-center"
      }, [_c("svg", {
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          "xmlns:xlink": "http://www.w3.org/1999/xlink",
          viewBox: "0 0 150.2 150.2"
        }
      }, [_c("path", {
        staticClass: "path",
        attrs: {
          d: "M 10,10 l 90,90 M 100,10 l -90,90",
          stroke: "red",
          "stroke-width": "10"
        }
      })]), _vm._v(" Not sent! ")]), _c("div", [_c("div", {
        staticClass: "mt-1"
      }, [_c("strong", [_vm._v(_vm._s(emailTemplate.name) + ":")])]), _c("div", {
        staticClass: "text-italic mb-1",
        staticStyle: {
          "font-size": "1rem"
        }
      }, [_vm._v(" " + _vm._s(emailTemplate.from) + " "), _c("i", {
        staticClass: "fas fa-paper-plane mx-2",
        staticStyle: {
          "font-size": "0.85rem"
        }
      }), _vm._v(" " + _vm._s(emailTemplate.sendTo && emailTemplate.sendTo.join(", ")) + " ")]), _c("div", {
        staticClass: "text-italic"
      }, _vm._l(emailTemplate.files, function (file) {
        return _c("a", {
          key: "file_".concat(file.id, "_").concat(file.name),
          staticClass: "mr-2",
          attrs: {
            href: !!file.blob ? file.url : _vm.URL.createObjectURL(file),
            target: "_blank"
          }
        }, [_c("i", {
          staticClass: "fas fa-paperclip"
        }), _vm._v(" " + _vm._s(file.id || file.name) + " ")]);
      }), 0)])])], 1);
    })], 2) : _c("div", {
      staticClass: "errorLabel mt-3"
    }, [_vm._v(" No custom mail has been configured. Are you sure to continue ? ")]), _c(VExpandTransition, [_vm.hasFailedSending ? _c(VAlert, {
      staticClass: "--error my-2",
      attrs: {
        type: "error",
        outlined: "",
        dense: ""
      }
    }, [_vm._v(' Some custom emails were not sent! You must use the button "Send mail" on top of order details to resend them. ')]) : _vm._e()], 1), _c("div", {
      staticClass: "stepper-btn"
    }, [_c(VBtn, {
      attrs: {
        color: "primary",
        loading: _vm.isUpdatingStatus,
        disabled: _vm.isInvalidMainForm || _vm.hasFailedSending,
        "data-cy": "step-synthesis-continue-btn"
      },
      on: {
        click: _vm.validateMain
      }
    }, [_vm._v(" " + _vm._s(_vm.form.emailTemplates.length > 0 ? "Save & Send" : "Save") + " ")])], 1)], 1) : _vm._e()], 1)];
  })], 2)]], 2), _vm.templateModalShown ? _c("MailTemplateModal", {
    attrs: {
      shown: _vm.templateModalShown,
      placeholders: _vm.emailPlaceholders,
      template: _vm.editableTemplate
    },
    on: {
      save: _vm.saveTemplate,
      close: _vm.closeTemplateModal
    }
  }) : _vm._e(), _c("Confirm", {
    ref: "confirm"
  }), _c("ErrorModal", {
    ref: _vm.ERROR_DATA.ref
  })], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };